export enum SaleSendToKsefValidationError {
    InvalidSchema = 'InvalidSchema',
    KsefStartDate = 'KsefStartDate',
    KsefIdNotAssignedForAdjustedDocument = 'KsefIdNotAssignedForAdjustedDocument',
    DocumentIssueDateMustBeNotFromFuture = 'DocumentIssueDateMustBeNotFromFuture',
    DuringProcessing = 'DuringProcessing',
    InvalidSellerCountryCode = 'InvalidSellerCountryCode',
    InvalidClientCountryCode = 'InvalidClientCountryCode',
    InvalidCurrencySymbol = 'InvalidCurrencySymbol',
    DocumentIsTraditional = 'DocumentIsTraditional',
    RoleOfOtherSellerNotExist = 'RoleOfOtherSellerNotExist',
    NetCalculationNotAllowedForNonVatTaxpayer = 'NetCalculationNotAllowedForNonVatTaxpayer'
}
